import * as XLSX from 'xlsx';

export const exportConveniosExcel = (convenios, obraSocialNombre) => {
  const wb = XLSX.utils.book_new();
  const ws = XLSX.utils.json_to_sheet(convenios.map(c => ({
    'Obra Social': c.obraSocial,
    'Código': c.codigo,
    'Tipo de Estudio': c.tipoEstudio,
    'Costo': c.costo,
    'Copago': c.copago,
    'Fecha Convenio': c.fConvenio ? new Date(c.fConvenio).toLocaleDateString('es-AR') : '',
    'Última Actualización': c.fModif ? new Date(c.fModif).toLocaleDateString('es-AR') : '',
    'Observación': c.observacion || '',
  })));

  const colWidths = [25, 12, 30, 12, 12, 16, 18, 30];
  ws['!cols'] = colWidths.map(w => ({ wch: w }));

  const nombre = obraSocialNombre || 'Todas';
  const fecha = new Date().toLocaleDateString('es-AR').replace(/\//g, '-');
  XLSX.utils.book_append_sheet(wb, ws, 'Convenios');
  XLSX.writeFile(wb, `Convenios_${nombre}_${fecha}.xlsx`);
};
